<template>
    <div>
        <Head title="Maps"/>
        <h1 class="mb-8 text-3xl font-bold">Maps</h1>
        <div id="map" style="width: 100%; height: 35vw;"></div>
<!--        <InfoModal-->
<!--            :show="showModal"-->
<!--            :selectedPoint="selectedPoint"-->
<!--            :types = "types"-->
<!--            @update:show="showModal = $event"-->
<!--        />-->
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import InfoModal from '@/Component/InfoModal'

export default {
    components: {
        Head,
        InfoModal
    },
    layout: Layout,
    props: {
        points: Array,
        types: Array,
        mapKey: String
    },
    data() {
        return {
            showModal: false,
            selectedPoint: {},
        };
    },
    mounted() {
        this.loadGoogleMapsScript().then(() => {
            this.initNewMap();
        });
    },
    methods: {
        getFontAwesomeIconUrl(iconName) {
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white" stroke="red"
                             stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin">
                            <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>`
            return `data:image/svg+xml;base64,${btoa(svg)}`;
        },
        loadGoogleMapsScript() {
            return new Promise((resolve, reject) => {
                if (window.google && window.google.maps) {
                    resolve();
                } else {
                    const script = document.createElement('script');
                    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.mapKey}&callback`;
                    script.async = true;
                    script.defer = true;
                    document.head.appendChild(script);
                    script.onload = () => {
                        resolve();
                    };
                    script.onerror = (error) => {
                        reject(error);
                    };
                }
            });
        },
        initNewMap() {
            const map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: 50.6751424, lng: 34.6299991},
                zoom: 14,
                mapTypeId: google.maps.MapTypeId.SATELLITE
            });

            this.points.forEach(point => {
                let marker = new google.maps.Marker({
                    position: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)},
                    map: map,
                    title: point.name,
                    icon: this.getFontAwesomeIconUrl('map-marker-alt')
                });

                // marker.addListener('click', () => {
                //     this.selectedPoint = point;
                //     this.showModal = true;
                // });
            })
        },
    },
}
</script>


